import { AnimatedEntrance } from '@/components/AnimatedEntrance';
import { FeedbackToast } from '@/components/FeedbackToast';
import { Footer } from '@/components/Footer';
import { Navbar } from '@/components/Navbar';
import { NewsFeed } from '@/components/NewsFeed';
import { NewsFilters } from '@/components/NewsFilters';

export default function Home() {
  return (
    <div className="flex min-h-screen flex-col bg-neutral-50 text-neutral-800">
      <AnimatedEntrance />
      <Navbar />

      <main className="mx-auto w-full max-w-5xl flex-1 px-4 pb-8 pt-28 sm:px-6 lg:px-8">
        <NewsFilters />
        <NewsFeed />
      </main>

      <Footer />
      <FeedbackToast />
    </div>
  );
}
